import { Route } from "react-router-dom";
import { RoutesTypes } from "../types/routes.types.js";

export const buildRoutes = (routes: RoutesTypes) =>
    routes.map(({ path, element }) => <Route path={path} element={element} key={Array.isArray(path) ? path[0] : path} />);
